import React from "react";
import TextField from '@mui/material/TextField';


export const APITextField = (props) => {
    const {errors = [], ...textFieldProps} = props;

    let errMsg = ""
    
    if (errors.length > 0) {
        errMsg = errors.map(({message}) => `${message}`).reduce((msg1, msg2) => `${msg1}\n${msg2}`)
    }

    return (
        <TextField 
            error={!!errMsg}
            helperText={errMsg}
            {...textFieldProps}
        />
    )
}